import AppDownloadMobile1x from './background-images/sv/app-download-mobile-1x.png';
import AppDownloadMobile2x from './background-images/sv/app-download-mobile-2x.png';
import AppDownloadMobile3x from './background-images/sv/app-download-mobile-3x.png';

import AppDownloadMobile1xDa from './background-images/da/app-download-mobile-1x.png';
import AppDownloadMobile2xDa from './background-images/da/app-download-mobile-2x.png';
import AppDownloadMobile3xDa from './background-images/da/app-download-mobile-3x.png';

import AppDownloadMobile1xDe from './background-images/de/app-download-mobile-1x.png';
import AppDownloadMobile2xDe from './background-images/de/app-download-mobile-2x.png';
import AppDownloadMobile3xDe from './background-images/de/app-download-mobile-3x.png';

import AppDownloadMobile1xFr from './background-images/fr/app-download-mobile-1x.png';
import AppDownloadMobile2xFr from './background-images/fr/app-download-mobile-2x.png';
import AppDownloadMobile3xFr from './background-images/fr/app-download-mobile-3x.png';

import AppDownloadMobile1xNl from './background-images/nl/app-download-mobile-1x.png';
import AppDownloadMobile2xNl from './background-images/nl/app-download-mobile-2x.png';
import AppDownloadMobile3xNl from './background-images/nl/app-download-mobile-3x.png';

import AppDownloadDesktop1x from './background-images/sv/app-download-desktop-1x.png';
import AppDownloadDesktop2x from './background-images/sv/app-download-desktop-2x.png';
import AppDownloadDesktop3x from './background-images/sv/app-download-desktop-3x.png';

import AppDownloadDesktop1xDa from './background-images/da/app-download-desktop-1x.png';
import AppDownloadDesktop2xDa from './background-images/da/app-download-desktop-2x.png';
import AppDownloadDesktop3xDa from './background-images/da/app-download-desktop-3x.png';

import AppDownloadDesktop1xDe from './background-images/de/app-download-desktop-1x.png';
import AppDownloadDesktop2xDe from './background-images/de/app-download-desktop-2x.png';
import AppDownloadDesktop3xDe from './background-images/de/app-download-desktop-3x.png';

import AppDownloadDesktop1xFr from './background-images/fr/app-download-desktop-1x.png';
import AppDownloadDesktop2xFr from './background-images/fr/app-download-desktop-2x.png';
import AppDownloadDesktop3xFr from './background-images/fr/app-download-desktop-3x.png';

import AppDownloadDesktop1xNl from './background-images/nl/app-download-desktop-1x.png';
import AppDownloadDesktop2xNl from './background-images/nl/app-download-desktop-2x.png';
import AppDownloadDesktop3xNl from './background-images/nl/app-download-desktop-3x.png';

import GooglePlayQrCode from './qr-codes/sv/qr-code-google-play.svg';
import GooglePlayQrCodeDa from './qr-codes/da/qr-code-google-play.svg';
import GooglePlayQrCodeDe from './qr-codes/de/qr-code-google-play.svg';
import GooglePlayQrCodeFr from './qr-codes/fr/qr-code-google-play.svg';
import GooglePlayQrCodeNl from './qr-codes/nl/qr-code-google-play.svg';

import AppstoreQrCode from './qr-codes/sv/qr-code-appstore.svg';
import AppstoreQrCodeDa from './qr-codes/da/qr-code-appstore.svg';
import AppstoreQrCodeDe from './qr-codes/de/qr-code-appstore.svg';
import AppstoreQrCodeFr from './qr-codes/fr/qr-code-appstore.svg';
import AppstoreQrCodeNl from './qr-codes/nl/qr-code-appstore.svg';

export const getMobileBackgroundImage = (language: string | null) => {
    let srcSet = `${AppDownloadMobile1x} 1x, ${AppDownloadMobile2x} 2x, ${AppDownloadMobile3x} 3x`;
    let src = AppDownloadMobile2x;

    switch (language) {
        case 'da':
            src = AppDownloadMobile2xDa;
            srcSet = `${AppDownloadMobile1xDa} 1x, ${AppDownloadMobile2xDa} 2x, ${AppDownloadMobile3xDa} 3x`;
            break;
        case 'de':
            src = AppDownloadMobile2xDe;
            srcSet = `${AppDownloadMobile1xDe} 1x, ${AppDownloadMobile2xDe} 2x, ${AppDownloadMobile3xDe} 3x`;
            break;
        case 'fr':
            src = AppDownloadMobile2xFr;
            srcSet = `${AppDownloadMobile1xFr} 1x, ${AppDownloadMobile2xFr} 2x, ${AppDownloadMobile3xFr} 3x`;
            break;
        case 'nl':
            src = AppDownloadMobile2xNl;
            srcSet = `${AppDownloadMobile1xNl} 1x, ${AppDownloadMobile2xNl} 2x, ${AppDownloadMobile3xNl} 3x`;
            break;
    }

    return {
        srcSet,
        src,
    };
};

export const getDesktopBackgroundImage = (language: string | null) => {
    let srcSet = `${AppDownloadDesktop1x} 1x, ${AppDownloadDesktop2x} 2x, ${AppDownloadDesktop3x} 3x`;
    let src = AppDownloadDesktop2x;

    switch (language) {
        case 'da':
            src = AppDownloadDesktop2xDa;
            srcSet = `${AppDownloadDesktop1xDa} 1x, ${AppDownloadDesktop2xDa} 2x, ${AppDownloadDesktop3xDa} 3x`;
            break;
        case 'de':
            src = AppDownloadDesktop2xDe;
            srcSet = `${AppDownloadDesktop1xDe} 1x, ${AppDownloadDesktop2xDe} 2x, ${AppDownloadDesktop3xDe} 3x`;
            break;
        case 'fr':
            src = AppDownloadDesktop2xFr;
            srcSet = `${AppDownloadDesktop1xFr} 1x, ${AppDownloadDesktop2xFr} 2x, ${AppDownloadDesktop3xFr} 3x`;
            break;
        case 'nl':
            src = AppDownloadDesktop2xNl;
            srcSet = `${AppDownloadDesktop1xNl} 1x, ${AppDownloadDesktop2xNl} 2x, ${AppDownloadDesktop3xNl} 3x`;
            break;
    }

    return {
        srcSet,
        src,
    };
};

export const getGooglePlayQrCode = (language: string | null) => {
    let src = GooglePlayQrCode;

    switch (language) {
        case 'da':
            src = GooglePlayQrCodeDa;
            break;
        case 'de':
            src = GooglePlayQrCodeDe;
            break;
        case 'fr':
            src = GooglePlayQrCodeFr;
            break;
        case 'nl':
            src = GooglePlayQrCodeNl;
            break;
    }

    return src;
};

export const getAppstoreQrCode = (language: string | null) => {
    let src = AppstoreQrCode;

    switch (language) {
        case 'da':
            src = AppstoreQrCodeDa;
            break;
        case 'de':
            src = AppstoreQrCodeDe;
            break;
        case 'fr':
            src = AppstoreQrCodeFr;
            break;
        case 'nl':
            src = AppstoreQrCodeNl;
            break;
    }

    return src;
};
